module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/download_app_food-57ba2950fc8bec5dc85c47776c41d8ac.png";